import * as React from 'react'
import { MonitorListCard } from 'components/MonitorListCard'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import { useState, useEffect } from 'react'
import Box from '@mui/material/Box'
import { Link } from 'react-router-dom'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import { setMainBarSettings, setParentUrl } from 'store/applicationSlice'
import { useAppDispatch } from 'shared/hooks'

export function MonitorListPage() {
    const [viewMode, setViewMode] = useState('table');
    const theme = useTheme();
    const isNarrowScreen = useMediaQuery(theme.breakpoints.down("md"));
    const dispatch = useAppDispatch()

    const viewModeChanged = (
        event: React.MouseEvent<HTMLElement>,
        newViewMode: string,
    ) => {
        setViewMode(newViewMode);
    };

    const viewTasksRender = () => {
        return (
            <MonitorListCard></MonitorListCard>
        )
    }

    useEffect(() => {
        setViewMode(isNarrowScreen ? 'cards' : 'table')
    }, [isNarrowScreen]);

    useEffect(() => {
        dispatch(setMainBarSettings({
            back: {
                url: '/market'
            },
            title: 'Market Spies'
        }))
        dispatch(setParentUrl(`/market`))

        return () => {
            dispatch(setMainBarSettings(undefined))
            dispatch(setParentUrl(undefined))
        }
    });

	return (
        <Box >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    margin: '26px 0 0 0'
                }}
            >
                <Stack direction="row" spacing={2}>
                    <Link to="/spy/create">
                        <Button
                            variant="contained"
                            color="success"
                            sx={{
                                minWidth: 330,
                                minHeight: 48,
                                fontSize: '20px',
                                textTransform: 'capitalize'
                            }}
                        >
                            Create Market Spies
                        </Button >
                    </Link>
                </Stack>
            </Box>
            {
                viewTasksRender()
            }  
		</Box>
	);
}
